import { lang } from '@umu/ukit-lang';
import { PARTICIPATE_STATUS, PLAN_TYPE } from '@umu/umu-types';

export const KEYWORD_COLORS = ['#FEBD2B', '#E75A2D', '#6739B7', '#23A565'];
/**
 * 学员没有权限的管理
 */
export const NO_PERMISSION = [PARTICIPATE_STATUS.ONSTART, PARTICIPATE_STATUS.ONEND];

export const homeworkTypeNameMap: { [props: number]: string } = {
    1: lang('语音作业'),
    2: lang('视频作业'),
    3: lang('图文作业'),
    4: lang('文档作业'),
    5: lang('动作练习作业'),
};

export const PLAN_VERSION_TYPE: Record<PLAN_TYPE, string> = {
    1: lang('基本版'),
    2: lang('专业版'),
    3: lang('团队版'),
    4: lang('企业版'),
    5: lang('机构版'),
};

export const DomType2SectionTypeMap: Record<string, number> = {
    /**
     * 段落文本说明
     */
    paragraph: 1,
    /**
     * 单选题
     */
    radio: 2,
    /**
     * 多选题
     */
    checkbox: 3,
    /**
     * 开放式问题（主观题）
     */
    textarea: 4,
    /**
     * 数值型问题
     */
    number: 5,
};

export const defaultPageInfo = {
    size: 20,
    current_page: 1,
    list_total_num: 0,
    total_page_num: 1,
};

export const defaultPageInfo0 = {
    size: 20,
    current_page: 0,
    list_total_num: 0,
    total_page_num: 1,
};

export const SESSION_TYPE_NAMES: {
    [key: number]: string;
} = {
    1: lang('问卷'),
    2: lang('提问'),
    3: lang('讨论'),
    4: lang('拍照'),
    5: lang('游戏'),
    6: lang('签到'),
    7: lang('微课'),
    8: lang('抽奖'),
    9: lang('报名'),
    10: lang('考试'),
    11: lang('视频'),
    12: lang('直播'),
    13: lang('文章'),
    14: lang('文档'),
    15: lang('图文'),
    16: lang('作业'),
    17: lang('会议'),
    18: lang('直播'),
    19: lang('AI微课'),
    20: lang('阶段点评'),
};

export const SESSION_TYPES = {
    SURVEY: '1',
    ASK: '2',
    DISCUSSION: '3',
    PHOTO: '4',

    GAME: '5',
    ATTENDANCE: '6',
    MINI_COURSE: '7',
    RAFFLE_DRAWING: '8',
    REGISTRATION: '9',
    QUIZ: '10',
    VIDEO: '11',
    LIVE: '12',
    ARTICLE: '13',
    DOCUMENTS: '14',
    IMAGE_ARTICLE: '15',
    HOMEWORK: '16',
    MEETING: '17',
    LIVE_PRO: '18',
    AI_AUDIO_SLIDES: '19',
};

export const SESSION_TYPE_ALIAS = {
    /**
     * 问卷
     */
    TYPE_SURVEY: 1,

    /**
     * 提问
     */
    TYPE_ASK: 2,

    /**
     * 讨论
     */
    TYPE_DISCUSSION: 3,

    /**
     * 拍照
     */
    TYPE_PHOTO: 4,

    /**
     * 游戏
     */
    TYPE_GAME: 5,

    /**
     * 签到
     */
    TYPE_ATTENDANCE: 6,

    /**
     * 微课
     */
    TYPE_MINI_COURSE: 7,

    /**
     * 抽奖
     */
    TYPE_LOTTERY: 8,

    /**
     * 报名
     */
    TYPE_REGISTRATION: 9,

    /**
     * 考试
     */
    TYPE_QUIZ: 10,

    /**
     * 视频
     */
    TYPE_VIDEO: 11,

    /**
     * 直播
     */
    TYPE_LIVE: 12,

    /**
     * 直播
     */
    TYPE_LIVE_PRO: 18,

    /**
     * 文章
     */
    TYPE_ARTICLE: 13,

    /**
     * 文件
     */
    TYPE_DOCUMENTS: 14,

    /**
     * 图文
     */
    TYPE_IMAGE_ARTICLE: 15,

    /**
     * 作业
     */
    TYPE_HOMEWORK: 16,

    /**
     * 会议
     */
    TYPE_MEETING: 17,

    /**
     * ai微课
     */
    TYPE_AI_AUDIO_SLIDES: 19,
    /**
     * 阶段点评
     */
    TYPE_STAGE_REVIEWS: 20,

    __NEXT__: '',
};

export const Live = {
    // 'READY','ONGOING','PAUSED','FAILED','CONNECTING'
    /**
     * 已创建直播，等待开始推送直播数据
     */
    STATUS_READY: 'READY',

    /**
     * 正在直播
     */
    STATUS_ONGOING: 'ONGOING',

    /**
     * 直播暂停（本次不支持暂停，只要暂停就认为结束）
     */
    STATUS_PAUSED: 'PAUSED',

    /**
     * 异常情况
     */
    STATUS_FAILED: 'FAILED',

    /**
     * 有状态，但文档中没有使用过，忽略
     */
    STATUS_CONNECTING: 'CONNECTING',

    __NEXT__: '',
};

export const SESSION_TYPE_COLOR: {
    [key: number]: string;
} = {
    1: '#23a565',
    2: '#ffa726',
    3: '#e75a2d',
    4: '#03a9f4',
    5: '#ff7d7a',
    6: '#00bcd4',
    7: '#2196f3',
    8: '#f596aa',
    9: '#3f51b5',
    10: '#673ab7',
    11: '#dd4e40',
    12: '#66bb6a',
    13: '#23a565',
    14: '#03a9f4',
    15: '#ffa726',
    16: '#ffbd2b',
    18: '#66bb6a',
    19: '#2197f3',
    20: '#1e6ee6',
};

/**
 * 小节类型对应的iconfont的名字，需要配合umu-design中的iconfont组件使用
 */
export const SESSION_TYPE_ICONFONT_NAME: {
    [key: number]: string;
} = {
    0: 'Catalogue', // 小节列表
    1: 'ItemSurvey',
    2: 'ItemQA', // lang('提问'),
    3: 'ItemDiscussion', // lang('讨论'),
    4: 'ItemFlipchartSlides', // lang('拍照'),
    5: 'ItemGameBreak', // lang('游戏'),
    6: 'ItemAttendance', // lang('签到'),
    7: 'ItemAudioSlides', // lang('微课'),
    8: 'ItemRaffleDrawing', // lang('抽奖'),
    9: 'ItemRegistration', // lang('报名'),
    10: 'ItemQuiz', // lang('考试'),
    11: 'ItemVideo', // lang('视频'),
    12: 'ItemLiveStream', // lang('直播'),
    13: 'ItemArticle', // lang('文章'),
    14: 'ItemDocument', // lang('文档'),
    15: 'ItemInfographic', // ang('图文'),
    16: 'ItemExercise', // lang('作业'),
    17: 'ItemMeeting', // lang('会议'),
    18: 'ItemLiveStream', // lang('直播'),
    19: 'ItemAIAudioSlides', // lang('AI微课'),
    20: 'StageComments', // lang('阶段点评'),
};